export const ConstMyWorkViews = [
    {
        id: 'home.my-work',
        name: 'My work',
        managerAlwaysOn: true,
        userAlwaysOn: true,
        guestAlwaysOn: true,
        clientAlwaysOn: true,
        sortPosition: 1,
    },
    {
        id: 'home.notifications',
        name: 'Notifications',
        managerAlwaysOn: true,
        userAlwaysOn: true,
        guestAlwaysOn: true,
        clientAlwaysOn: true,
        sortPosition: 2
    },
    {
        id: 'home.my-time',
        name: 'My Time',
        sortPosition: 3
    },
    {
        id: 'home.my-tasks',
        name: 'My Tasks',
        sortPosition: 4
    },
    {
        id: 'home.my-workload',
        name: 'My Workload',
        sortPosition: 5
    },
    {
        id: 'home.my-calendar',
        name: 'My Calendar',
        sortPosition: 6
    },
    {
        id: 'home.my-meetings',
        name: 'My Meetings',
        sortPosition: 7
    },
    {
        id: 'home.recent',
        name: 'Recent',
        sortPosition: 8
    },
];

export const ConstToolsViews = [

    {
        id      : 'tools.activity-stream',
        name    : 'Activity stream',
        sortPosition: 20
    },
    {
        id      : 'tools.gantt-all-projects',
        name    : 'Gantt - all projects',
        sortPosition: 21
    },
    {
        id      : 'tools.resource-planning',
        name    : 'Resource planning',
        sortPosition: 22
    },
    {
        id      : 'tools.board-all-tasks',
        name    : 'Board - all tasks',
        sortPosition: 23
    },
    {
        id      : 'tools.tasks-by-user',
        name    : 'Tasks by user',
        sortPosition: 24
    },
    {
        id      : 'tools.whats-done',
        name    : 'What\'s done',
        sortPosition: 25
    },
    {
        id      : 'tools.events-summary',
        name    : 'Events summary',
        sortPosition: 26
    },
    {
        id      : 'tools.pastdue',
        name    : 'Pastdue',
        sortPosition: 27
    },
    {
        id      : 'tools.calendar-vacations',
        name    : 'Vacations Calendar',
        sortPosition: 28
    },
    {
        id      : 'projects.portfolio',
        name    : 'Portfolio',
        sortPosition: 29
    },
];

